import AssociationRelationshipRequest from '@core/classes/AssociationRelationshipRequest';
import { AxiosResponse } from 'axios';
import DocumentAssociation from '@core/classes/DocumentAssociation';
import request from '@core/services/request';

export interface IAssociationLookupResponse {
	source: DocumentAssociation;
	results: DocumentAssociation[];
}

export const associationsAPI = {
	getAssociationRelationships: (req: AssociationRelationshipRequest): Promise<AxiosResponse<IAssociationLookupResponse>> => {
		return request.post(`/Lookup/AssociationRelationships`, req);
	},

	getAssociationsRelationships: (req: AssociationRelationshipRequest[]): Promise<AxiosResponse<IAssociationLookupResponse[]>> => {
		return request.post(`/Lookup/AssociationsRelationships`, req);
	},
};
